// Component: Countdown
// Author: Vijay Radhakrishnan
import * as React from 'react';
import CountdownTimerNPM from '@component/CountdownTimer';
import { Text, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { RoutableLink } from '../../react/RoutableLink';
import EditableLink from '../../react/EditableLink';
import WBRString from '@component/WbrString';
import i18n from 'i18next';

const CountdownTimer = (props) => {
  const isEditing = props.sitecoreContext && props.sitecoreContext.pageEditing;

  let Link = null;
  if (props?.fields?.LinkText && props?.fields?.LinkText?.value !== '') {
    Link = (
      <>
        <RoutableLink field={props.fields.Link} useATag={true}>
          <WBRString tag="span">
            <Text field={props.fields.LinkText} />
          </WBRString>
        </RoutableLink>
      </>
    );
  }
  var CountdownData = {
    Text: <Text field={props.fields.Title} />,
    TargetDate: props.fields.TargetDate.value,
    Language: {
      Days: i18n.t('term/days'),
      Hours: i18n.t('term/hours'),
      Minutes: i18n.t('term/mins'),
      Seconds: i18n.t('term/secs'),
    },
    Link: Link,
  };

  return (
    <>
      <CountdownTimerNPM {...CountdownData} />
    </>
  );
};

export default withSitecoreContext()(CountdownTimer);
